export default postType => {

	const sanitizedPostType = postType === 'page'
		? 'pages' : postType === 'post'
			? 'posts' : postType

	return sanitizedPostType;

}
